var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "choose-seal-mobile" },
    [
      _c("van-nav-bar", {
        attrs: { title: "添加印章", "left-arrow": "" },
        on: { "click-left": _vm.goBack },
      }),
      _vm._v(" "),
      _c(
        "van-tabs",
        {
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        _vm._l(_vm.tabItems, function (item, index) {
          return _c(
            "van-tab",
            {
              key: index,
              attrs: {
                disabled: index !== 0,
                title: item.label,
                name: item.value,
              },
            },
            [
              _vm.personalSealList.length > 0
                ? _vm._l(_vm.sliceSealList, function (item, idx) {
                    return _c(
                      "div",
                      { key: idx, staticClass: "seal-row" },
                      _vm._l(_vm.sliceSealList[idx], function (child, i) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.active === 0 && child.downloadUrl,
                                expression: "active === 0 && child.downloadUrl",
                              },
                            ],
                            key: i,
                            staticClass: "seal-item",
                            class: child.isChoosed ? "isChecked" : "",
                          },
                          [
                            _c("img", {
                              staticClass: "seal-item-img",
                              attrs: { src: child.downloadUrl, alt: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.choosePersonSeal(child)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    )
                  })
                : [
                    _c("van-empty", { attrs: { description: "暂无数据" } }),
                    _vm._v(" "),
                    _vm.loading
                      ? _c(
                          "van-loading",
                          {
                            staticClass: "seal-list-loading",
                            attrs: {
                              vertical: "",
                              color: "#1989fa",
                              type: "spinner",
                            },
                          },
                          [_vm._v("加载中...")]
                        )
                      : _vm._e(),
                  ],
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "van-button",
        { attrs: { type: "info", block: "" }, on: { click: _vm.confirm } },
        [_vm._v("确 定")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }